import {ON_BANK_BRANCH_LIST} from '../constants/ActionTypes';

const INIT_STATE = {
    bankBranchList: []
};


export default (state=INIT_STATE,action) => {
    switch (action.type){

        case ON_BANK_BRANCH_LIST: {
            return {...state, bankBranchList: action.payload};
        }
        default:
            return state;
    }
}